import { DataBean } from "../DataBean";

export class TransportGuideLiquidator extends DataBean {
    public async deleteTransportGuideLiquidator(idTransportGuideLiquidator: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportGuideLiquidator_Number", [idTransportGuideLiquidator]);
    }
    public async getTransportGuideLiquidatorCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportGuideLiquidatorCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}